module.exports = "/packs/radio-blank-c68cb12716144e8aebee021c26336cd6.svg";